import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Cookies from "universal-cookie";
import { Navigate, BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthHelperMethods from "./components/auth/AuthHelperMethods";
import withAuth from "./components/auth/withAuth";
import { createStore } from "redux";
import rootReducer from "./reducers";
import { WikiWrapperEl, GlobalStyle } from "./components/body/styles/WikiWrapper";
import { AdminConsoleEl, AdminGlobalStyle } from "./components/body/styles/AdminWrapper";
import logo from "./images/logo.svg";
import { withRouterV6 } from "./withRouterV6";

const store = createStore(rootReducer);

class AdminWrapper extends Component {
	Auth = new AuthHelperMethods();
	constructor(props) {
		super(props);
		this.state = {
			logout: false,
			redirect: "",
			title: "",
			value: "",
			settings: [],
			form: [],
			// Console UI state
			activeIndex: 0,
			draftTag: "",
			savingTitle: "",
			savedTitle: "",
			showAdd: false,
			editorMode: {},
			activeTabs: {}
		};
	}

	fetchAdmin = () => {
		this.fetchAdminAll();
		this.Auth.fetchAdmin({ user: this.state.user._id })
			.then((res) => {
				if (res.error) {
					alert(res.error);
				} else if (res.data.settings) {
					this.setState({ form: res.data.settings });
				}
			})
			.catch((err) => console.error("[ fetchAdmin ] POST error:", err));
	};

	fetchAdminAll = () => {
		this.Auth.fetchAdmin({ user: this.state.user._id })
			.then((res) => {
				if (res.error) {
					alert(res.error);
				} else if (res.data.settings) {
					let obj = {};
					res.data.settings.forEach((item) => (obj[item.title] = item.value));
					obj.tags = obj.tags.split("\n");
					obj.departments = JSON.parse(obj.departments);
					obj.copy_data = JSON.parse(obj.copy_data);
					this.setState({ settings: obj });
				}
			})
			.catch((err) => console.error("[ fetchAdminAll ] POST error:", err));
	};

	edit = (event) => {
		event.preventDefault();
		const post_data = {
			id: event.target.id.value,
			title: event.target.title.value,
			value: event.target.value.value,
			description: event.target.description.value,
			user: this.state.user
		};

		this.Auth.editAdmin(post_data)
			.then((res) => {
				if (res.error) {
					alert(res.error);
				} else {
					this.fetchAdmin();
				}
			})
			.catch((err) => console.error("[ edit ] POST error:", err));
	};

	handleValueFormChange = (event) => {
		const { name, value } = event.target;
		// Extract the keys from the input name attribute
		const keys = name.split("--");
		// Copy the current settings state to modify
		let updatedSettings = [...this.state.form];
		// Find the specific setting and update its nested values recursively
		let data = updatedSettings.find((setting) => setting.title === keys[0]);
		if (data) {
			// Nested JSON path update
			let schema = data.value ? JSON.parse(data.value) : {};
			let temp = schema;
			// Navigate through the schema except for the last key
			keys.slice(1, -1).forEach((key, index) => {
				// Check if navigating an array or object
				if (!isNaN(parseInt(key)) && Array.isArray(temp)) {
					temp = temp[parseInt(key)];
				} else if (!temp[key]) {
					// Initialize as an object or array based on the next key, if missing
					temp[key] = isNaN(parseInt(keys[index + 1])) ? {} : [];
				} else {
					temp = temp[key];
				}
			});
			const finalKey = keys[keys.length - 1];
			if (!isNaN(parseInt(finalKey)) && Array.isArray(temp)) {
				// If finalKey is an index and temp is an array, replace the whole item at this index
				temp[parseInt(finalKey)] = value;
			} else {
				// Otherwise, treat it as a key of an object
				temp[finalKey] = value;
			}
			// Update the setting's value with the new JSON string
			data.value = JSON.stringify(schema, null, "\t");
			const formElement = event.target.form;
			const valueInput = formElement.querySelector('[name="value"]');
			if (valueInput) {
				valueInput.value = data.value;
			}
		}
		// Update the form state with new data
		this.setState({
			form: updatedSettings
		});
	};

	// ----------
	// Console helpers
	// ----------
	selectSetting = (index) => {
		this.setState({ activeIndex: index, showAdd: false, savedTitle: "" });
	};

	updateSettingValue = (title, value) => {
		this.setState((prev) => ({
			savedTitle: "",
			form: prev.form.map((s) => (s.title === title ? { ...s, value: value } : s))
		}));
	};

	updateSettingField = (title, field, value) => {
		this.setState((prev) => ({
			savedTitle: "",
			form: prev.form.map((s) => (s.title === title ? { ...s, [field]: value } : s))
		}));
	};

	saveSetting = (setting) => {
		this.setState({ savingTitle: setting.title });
		this.Auth.editAdmin({
			id: setting._id,
			title: setting.title,
			value: setting.value,
			description: setting.description || "",
			user: this.state.user
		})
			.then((res) => {
				if (res.error) {
					alert(res.error);
					this.setState({ savingTitle: "" });
				} else {
					this.setState({ savingTitle: "", savedTitle: setting.title }, this.fetchAdmin);
				}
			})
			.catch((err) => {
				console.error("[ saveSetting ] POST error:", err);
				this.setState({ savingTitle: "" });
			});
	};

	isJsonValue = (value) => {
		if (typeof value !== "string") return false;
		const trimmed = value.trim();
		if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return false;
		try {
			const parsed = JSON.parse(trimmed);
			return typeof parsed === "object" && parsed !== null;
		} catch (e) {
			return false;
		}
	};

	formatJson = (setting) => {
		try {
			this.updateSettingValue(setting.title, JSON.stringify(JSON.parse(setting.value), null, "\t"));
		} catch (e) {
			alert("Invalid JSON — cannot format.");
		}
	};

	// ---- Tags (newline-delimited list) ----
	getTags = (setting) => (setting.value ? setting.value.split("\n").filter((t) => t.length > 0) : []);

	isTagHeading = (tag) => tag.match(/[$0-9]\./) !== null;

	addTag = (setting) => {
		const tag = this.state.draftTag.trim();
		if (!tag) return;
		const tags = this.getTags(setting);
		tags.push(tag);
		this.setState({ draftTag: "" });
		this.updateSettingValue(setting.title, tags.join("\n"));
	};

	removeTag = (setting, index) => {
		const tags = this.getTags(setting);
		tags.splice(index, 1);
		this.updateSettingValue(setting.title, tags.join("\n"));
	};

	// ---- Departments ({ name: { color: "r,g,b", ... } }) ----
	getDepartments = (setting) => {
		try {
			return Object.entries(JSON.parse(setting.value || "{}"));
		} catch (e) {
			return [];
		}
	};

	writeDepartments = (setting, entries) => {
		const obj = {};
		entries.forEach(([name, meta]) => {
			obj[name] = meta;
		});
		this.updateSettingValue(setting.title, JSON.stringify(obj, null, "\t"));
	};

	renameDepartment = (setting, index, name) => {
		const entries = this.getDepartments(setting);
		if (!entries[index]) return;
		entries[index] = [name, entries[index][1]];
		this.writeDepartments(setting, entries);
	};

	setDepartmentColor = (setting, index, hex) => {
		const entries = this.getDepartments(setting);
		if (!entries[index]) return;
		entries[index] = [entries[index][0], { ...entries[index][1], color: this.hexToRgbStr(hex) }];
		this.writeDepartments(setting, entries);
	};

	removeDepartment = (setting, index) => {
		const entries = this.getDepartments(setting);
		entries.splice(index, 1);
		this.writeDepartments(setting, entries);
	};

	addDepartment = (setting) => {
		const entries = this.getDepartments(setting);
		entries.push(["New Department", { color: "100,116,128" }]);
		this.writeDepartments(setting, entries);
	};

	rgbStrToHex = (rgb) => {
		const parts = String(rgb || "")
			.split(",")
			.map((s) => parseInt(s.trim(), 10));
		const clamp = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n));
		const hex = (n) => clamp(n).toString(16).padStart(2, "0");
		return `#${hex(parts[0])}${hex(parts[1])}${hex(parts[2])}`;
	};

	hexToRgbStr = (hex) => {
		const m = String(hex).replace("#", "");
		const r = parseInt(m.substring(0, 2), 16) || 0;
		const g = parseInt(m.substring(2, 4), 16) || 0;
		const b = parseInt(m.substring(4, 6), 16) || 0;
		return `${r},${g},${b}`;
	};

	// ---- Editor mode (visual <-> text) ----
	setEditorMode = (title, mode) => {
		this.setState((prev) => ({ editorMode: { ...prev.editorMode, [title]: mode } }));
	};

	setActiveTab = (key, value) => {
		this.setState((prev) => ({ activeTabs: { ...prev.activeTabs, [key]: value } }));
	};

	getActiveTab = (key, tabs) => {
		if (!tabs || tabs.length === 0) return "";
		const active = this.state.activeTabs[key];
		return tabs.some((tab) => tab.key === active) ? active : tabs[0].key;
	};

	humanize = (key) =>
		String(key)
			.replace(/_/g, " ")
			.replace(/\b\w/g, (c) => c.toUpperCase());

	tabKey = (value) =>
		String(value || "Other")
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "_")
			.replace(/^_+|_+$/g, "") || "other";

	renderTabs(tabKey, tabs, activeKey, className = "") {
		if (!tabs || tabs.length <= 1) return null;
		return (
			<div className={"admin-tabs " + className}>
				{tabs.map((tab) => (
					<button
						type="button"
						key={tab.key}
						className={"admin-tab" + (tab.key === activeKey ? " active" : "")}
						onClick={() => this.setActiveTab(tabKey, tab.key)}
					>
						<span>{tab.label}</span>
						{typeof tab.count === "number" && <span className="count">{tab.count}</span>}
					</button>
				))}
			</div>
		);
	}

	// ---- copy_data ({ category: [ {field: value}, ... ] }) ----
	getCopy = (setting) => {
		try {
			const obj = JSON.parse(setting.value || "{}");
			return obj && typeof obj === "object" ? obj : {};
		} catch (e) {
			return {};
		}
	};

	writeCopy = (setting, obj) => this.updateSettingValue(setting.title, JSON.stringify(obj, null, "\t"));

	updateCopyField = (setting, cat, index, field, value) => {
		const obj = this.getCopy(setting);
		if (!obj[cat] || !obj[cat][index]) return;
		obj[cat][index] = { ...obj[cat][index], [field]: value };
		this.writeCopy(setting, obj);
	};

	addCopyItem = (setting, cat, seed = {}) => {
		const obj = this.getCopy(setting);
		if (!Array.isArray(obj[cat])) obj[cat] = [];
		const template = obj[cat][0]
			? Object.keys(obj[cat][0])
			: ["title", "subject", "preheader", "hero", "introduction", "CTA", "cta_button"];
		const item = {};
		template.forEach((k) => (item[k] = ""));
		item.title = seed.title || "New entry";
		obj[cat].push(item);
		this.writeCopy(setting, obj);
	};

	removeCopyItem = (setting, cat, index) => {
		const obj = this.getCopy(setting);
		if (obj[cat]) {
			obj[cat].splice(index, 1);
			this.writeCopy(setting, obj);
		}
	};

	renameCopyCategory = (setting, oldName, newName) => {
		const obj = this.getCopy(setting);
		const next = {};
		Object.keys(obj).forEach((k) => {
			next[k === oldName ? newName : k] = obj[k];
		});
		this.writeCopy(setting, next);
	};

	removeCopyCategory = (setting, cat) => {
		const obj = this.getCopy(setting);
		delete obj[cat];
		this.writeCopy(setting, obj);
	};

	addCopyCategory = (setting) => {
		const obj = this.getCopy(setting);
		let name = "new_category";
		let n = 1;
		while (obj[name]) name = "new_category_" + ++n;
		obj[name] = [];
		this.writeCopy(setting, obj);
	};

	parseCopyTitle = (title) => {
		const clean = String(title || "").trim();
		const numberMatch = clean.match(/#\s*(\d+)/);
		const number = numberMatch ? parseInt(numberMatch[1], 10) : null;
		const withoutNumber = clean.replace(/#\s*\d+/, "").trim();
		const parts = withoutNumber.split(/\s+/).filter(Boolean);
		const main = parts[0] || "Other";
		const remainder = parts.slice(1).join(" ");
		let intent = remainder || "Other";

		if (/\b(ni|non[\s-]?incentive|no[\s-]?incentive)\b/i.test(remainder)) {
			intent = "NonIncentive";
		} else if (/\bincentive\b/i.test(remainder)) {
			intent = "Incentive";
		} else if (/\bbis\b/i.test(remainder)) {
			intent = "BIS";
		}

		return {
			main,
			mainKey: this.tabKey(main),
			intent,
			intentKey: this.tabKey(intent),
			email: number ? "Email " + number : "Other",
			emailKey: number ? "email_" + number : "other",
			emailNumber: number || 999
		};
	};

	copyIntentRank = (label) => {
		const order = ["Incentive", "NonIncentive", "BIS", "Other"];
		const idx = order.indexOf(label);
		return idx === -1 ? order.length : idx;
	};

	copyMainRank = (label) => {
		const order = ["SYC", "LC", "EM", "Anon", "OOS"];
		const idx = order.indexOf(label);
		return idx === -1 ? order.length : idx;
	};

	getCopyNameGroups = (setting) => {
		const obj = this.getCopy(setting);
		const groups = {};

		Object.entries(obj).forEach(([cat, items]) => {
			(Array.isArray(items) ? items : []).forEach((item, index) => {
				const parsed = this.parseCopyTitle(item.title);
				if (!groups[parsed.mainKey]) {
					groups[parsed.mainKey] = {
						key: parsed.mainKey,
						label: parsed.main,
						count: 0,
						intents: {}
					};
				}
				const mainGroup = groups[parsed.mainKey];
				mainGroup.count += 1;

				if (!mainGroup.intents[parsed.intentKey]) {
					mainGroup.intents[parsed.intentKey] = {
						key: parsed.intentKey,
						label: parsed.intent,
						count: 0,
						emails: {}
					};
				}
				const intentGroup = mainGroup.intents[parsed.intentKey];
				intentGroup.count += 1;

				if (!intentGroup.emails[parsed.emailKey]) {
					intentGroup.emails[parsed.emailKey] = {
						key: parsed.emailKey,
						label: parsed.email,
						count: 0,
						emailNumber: parsed.emailNumber,
						items: []
					};
				}
				const emailGroup = intentGroup.emails[parsed.emailKey];
				emailGroup.count += 1;
				emailGroup.items.push({ cat, index, item });
			});
		});

		return Object.values(groups).sort((a, b) => {
			const ranked = this.copyMainRank(a.label) - this.copyMainRank(b.label);
			return ranked !== 0 ? ranked : a.label.localeCompare(b.label);
		});
	};

	getCopyEntries = (setting) => {
		const obj = this.getCopy(setting);
		const entries = [];
		Object.entries(obj).forEach(([cat, items]) => {
			(Array.isArray(items) ? items : []).forEach((item, index) => {
				entries.push({ cat, index, item, parsed: this.parseCopyTitle(item.title) });
			});
		});
		return entries;
	};

	getCopyTabs = (entries, keyField, labelField, sortGroups) => {
		const groups = {};
		entries.forEach((entry) => {
			const key = entry.parsed[keyField];
			if (!groups[key]) {
				groups[key] = {
					key,
					label: entry.parsed[labelField],
					count: 0
				};
			}
			groups[key].count += 1;
		});
		const tabs = Object.values(groups).sort(sortGroups);
		return entries.length > 0 ? [{ key: "all", label: "All", count: entries.length }, ...tabs] : [];
	};

	// ---- *_tests ([ {case, section, tooltip}, ... ]) ----
	getTests = (setting) => {
		try {
			const arr = JSON.parse(setting.value || "[]");
			return Array.isArray(arr) ? arr : [];
		} catch (e) {
			return [];
		}
	};

	writeTests = (setting, arr) => this.updateSettingValue(setting.title, JSON.stringify(arr, null, "\t"));

	updateTestField = (setting, index, field, value) => {
		const arr = this.getTests(setting);
		if (!arr[index]) return;
		arr[index] = { ...arr[index], [field]: value };
		this.writeTests(setting, arr);
	};

	addTest = (setting, section = "") => {
		const arr = this.getTests(setting);
		const template = arr[0] ? Object.keys(arr[0]) : ["case", "section", "tooltip"];
		// AI Review entries also control ordering, CSD gating and agent context
		if (setting.title === "ai_tests") {
			["method", "requires", "fields"].forEach((k) => !template.includes(k) && template.push(k));
		}
		const item = {};
		template.forEach((k) => (item[k] = ""));
		item.case = "new_case";
		item.section = section || item.section || "";
		arr.push(item);
		this.writeTests(setting, arr);
	};

	removeTest = (setting, index) => {
		const arr = this.getTests(setting);
		arr.splice(index, 1);
		this.writeTests(setting, arr);
	};

	getTestGroups = (setting) => {
		const groups = {};
		this.getTests(setting).forEach((test, index) => {
			const label = test.section || "Unsectioned";
			const key = this.tabKey(label);
			if (!groups[key]) groups[key] = { key, label, count: 0, items: [] };
			groups[key].count += 1;
			groups[key].items.push({ test, index });
		});
		return Object.values(groups);
	};

	add = (event) => {
		event.preventDefault();
		const post_data = {
			title: this.state.title,
			value: this.state.value,
			description: this.state.description,
			user: this.state.user
		};

		this.Auth.addAdmin(post_data)
			.then((res) => {
				if (res.error) {
					alert(res.error);
				} else {
					this.fetchAdmin();
				}
			})
			.catch((err) => console.error("[ add ] POST error:", err));
	};

	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	};

	handleLogout = () => {
		if (!window.location.href.includes("localhost")) {
			this.Auth.logout();
			this.setState({ logout: true }, () => {
				this.props.history.replace("/login");
			});
		}
	};

	componentDidMount() {
		let cookies = new Cookies();
		let theme = cookies.get("theme") || "dark";
		document.documentElement.id = theme === "light" ? "light" : "dark";

		if (this.Auth.loggedIn()) {
			this.Auth.getProfile()
				.then((res) => {
					if (res.success && res.data && res.data.profile) {
						store.dispatch({
							type: "PROFILE",
							profile: res.data.profile
						});
						this.setState(
							{
								user: res.data,
								profile: res.data.profile,
								userId: res.data.id,
								ws: res.data.ws
							},
							this.fetchAdmin
						);
					} else {
						this.handleLogout();
					}
				})
				.catch((err) => {
					console.error("[ componentDidMount ] Error:", err);
					this.handleLogout();
				});
		} else {
			this.handleLogout();
		}
	}

	_handleLogout = () => {
		this.Auth.logout();
		this.setState({ logout: true }, function () {
			this.props.history.replace("/login");
		});
	};

	renderTagsEditor(setting, canEdit) {
		const tags = this.getTags(setting);
		return (
			<div className="admin-field">
				<p className="admin-help">
					Manage the tag list. Lines such as &ldquo;1. Section&rdquo; render as headings.
				</p>
				<div className="tag-chips">
					{tags.length === 0 && <span className="admin-help">No tags yet.</span>}
					{tags.map((tag, i) =>
						this.isTagHeading(tag) ? (
							<span className="tag-chip heading" key={i}>
								{tag}
							</span>
						) : (
							<span className="tag-chip" key={i}>
								{tag}
								{canEdit && (
									<button
										type="button"
										className="remove"
										title="Remove tag"
										onClick={() => this.removeTag(setting, i)}
									>
										&times;
									</button>
								)}
							</span>
						)
					)}
				</div>
				{canEdit && (
					<div className="tag-add">
						<input
							className="admin-input"
							placeholder="Add a tag…"
							value={this.state.draftTag}
							onChange={(e) => this.setState({ draftTag: e.target.value })}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
									this.addTag(setting);
								}
							}}
						/>
						<button type="button" className="btn-save" onClick={() => this.addTag(setting)}>
							Add
						</button>
					</div>
				)}
			</div>
		);
	}

	renderDepartmentsEditor(setting, canEdit) {
		const entries = this.getDepartments(setting);
		return (
			<div className="admin-field">
				<p className="admin-help">Each department has a name and a color used throughout the app.</p>
				<div className="dept-list">
					{entries.map(([name, meta], i) => (
						<div className="dept-row" key={i}>
							<label
								className="swatch"
								style={{ background: `rgb(${(meta && meta.color) || "100,116,128"})` }}
							>
								<input
									type="color"
									value={this.rgbStrToHex(meta && meta.color)}
									disabled={!canEdit}
									onChange={(e) => this.setDepartmentColor(setting, i, e.target.value)}
								/>
							</label>
							<input
								className="dept-name"
								value={name}
								readOnly={!canEdit}
								onChange={(e) => this.renameDepartment(setting, i, e.target.value)}
							/>
							{canEdit && (
								<button
									type="button"
									className="dept-delete"
									title="Delete department"
									onClick={() => this.removeDepartment(setting, i)}
								>
									&times;
								</button>
							)}
						</div>
					))}
				</div>
			</div>
		);
	}

	renderGenericEditor(setting, canEdit) {
		const json = this.isJsonValue(setting.value);
		return (
			<React.Fragment>
				<div className="admin-field">
					<label>Description</label>
					<input
						className="admin-input"
						value={setting.description || ""}
						readOnly={!canEdit}
						onChange={(e) => this.updateSettingField(setting.title, "description", e.target.value)}
					/>
				</div>
				<div className="admin-field">
					<label>Value{json ? " (JSON)" : ""}</label>
					<textarea
						className={"admin-textarea" + (json ? " mono" : "")}
						value={setting.value || ""}
						readOnly={!canEdit}
						onChange={(e) => this.updateSettingValue(setting.title, e.target.value)}
					/>
				</div>
				{json && canEdit && (
					<button type="button" className="btn-ghost" onClick={() => this.formatJson(setting)}>
						Format JSON
					</button>
				)}
			</React.Fragment>
		);
	}

	renderModeToggle(setting) {
		const mode = this.state.editorMode[setting.title] || "visual";
		return (
			<div className="editor-mode-toggle">
				<button
					type="button"
					className={"seg" + (mode === "visual" ? " active" : "")}
					onClick={() => this.setEditorMode(setting.title, "visual")}
				>
					Visual
				</button>
				<button
					type="button"
					className={"seg" + (mode === "text" ? " active" : "")}
					onClick={() => this.setEditorMode(setting.title, "text")}
				>
					Text
				</button>
			</div>
		);
	}

	renderTextMode(setting, canEdit) {
		const json = setting.title !== "tags";
		return (
			<div className="admin-field">
				<label>{json ? "Value (JSON)" : "Value — one tag per line"}</label>
				<textarea
					className={"admin-textarea" + (json ? " mono" : "")}
					value={setting.value || ""}
					readOnly={!canEdit}
					onChange={(e) => this.updateSettingValue(setting.title, e.target.value)}
				/>
				{json && canEdit && (
					<button type="button" className="btn-ghost" onClick={() => this.formatJson(setting)}>
						Format JSON
					</button>
				)}
			</div>
		);
	}

	renderObjectFields(obj, canEdit, onChange) {
		return Object.keys(obj).map((key) => {
			const val = obj[key];
			if (typeof val !== "string" && typeof val !== "number") {
				return (
					<div className="admin-field" key={key}>
						<label>{this.humanize(key)}</label>
						<p className="admin-help">Complex value — switch to Text mode to edit.</p>
					</div>
				);
			}
			const long = typeof val === "string" && (val.length > 60 || val.indexOf("\n") !== -1);
			return (
				<div className="admin-field" key={key}>
					<label>{this.humanize(key)}</label>
					{long ? (
						<textarea
							className="admin-textarea"
							value={val}
							readOnly={!canEdit}
							onChange={(e) => onChange(key, e.target.value)}
						/>
					) : (
						<input
							className="admin-input"
							value={val}
							readOnly={!canEdit}
							onChange={(e) => onChange(key, e.target.value)}
						/>
					)}
				</div>
			);
		});
	}

	renderCopyEditor(setting, canEdit) {
		const copy = this.getCopy(setting);
		const categories = Object.keys(copy);
		const entries = this.getCopyEntries(setting);
		const industryOptions = [
			{ key: "all", label: "All industries", count: entries.length },
			...categories.map((cat) => ({
				key: cat,
				label: cat,
				count: Array.isArray(copy[cat]) ? copy[cat].length : 0
			}))
		];
		const industryTabKey = setting.title + ":copy:industry";
		const activeIndustry = this.getActiveTab(industryTabKey, industryOptions);
		const industryEntries =
			activeIndustry === "all" ? entries : entries.filter((entry) => entry.cat === activeIndustry);
		const mainTabKey = setting.title + ":copy:main";
		const mainTabs = this.getCopyTabs(industryEntries, "mainKey", "main", (a, b) => {
			const ranked = this.copyMainRank(a.label) - this.copyMainRank(b.label);
			return ranked !== 0 ? ranked : a.label.localeCompare(b.label);
		});
		const activeMainKey = this.getActiveTab(mainTabKey, mainTabs);
		const mainEntries =
			activeMainKey === "all"
				? industryEntries
				: industryEntries.filter((entry) => entry.parsed.mainKey === activeMainKey);
		const intentTabKey = setting.title + ":copy:" + activeMainKey + ":intent";
		const intentTabs = this.getCopyTabs(mainEntries, "intentKey", "intent", (a, b) => {
			const ranked = this.copyIntentRank(a.label) - this.copyIntentRank(b.label);
			return ranked !== 0 ? ranked : a.label.localeCompare(b.label);
		});
		const activeIntentKey = this.getActiveTab(intentTabKey, intentTabs);
		const intentEntries =
			activeIntentKey === "all"
				? mainEntries
				: mainEntries.filter((entry) => entry.parsed.intentKey === activeIntentKey);
		const emailTabKey = setting.title + ":copy:" + activeMainKey + ":" + activeIntentKey + ":email";
		const emailTabs = this.getCopyTabs(intentEntries, "emailKey", "email", (a, b) => {
			const aNum = a.key.match(/^email_(\d+)$/) ? parseInt(a.key.replace("email_", ""), 10) : 999;
			const bNum = b.key.match(/^email_(\d+)$/) ? parseInt(b.key.replace("email_", ""), 10) : 999;
			const ranked = aNum - bNum;
			return ranked !== 0 ? ranked : a.label.localeCompare(b.label);
		});
		const activeEmailKey = this.getActiveTab(emailTabKey, emailTabs);
		const activeItems =
			activeEmailKey === "all"
				? intentEntries
				: intentEntries.filter((entry) => entry.parsed.emailKey === activeEmailKey);
		const sortedItems = activeItems
			.slice()
			.sort(
				(a, b) =>
					a.cat.localeCompare(b.cat) ||
					this.copyMainRank(a.parsed.main) - this.copyMainRank(b.parsed.main) ||
					this.copyIntentRank(a.parsed.intent) - this.copyIntentRank(b.parsed.intent) ||
					a.parsed.emailNumber - b.parsed.emailNumber ||
					String(a.item.title || "").localeCompare(String(b.item.title || ""))
			);
		const missingCategories =
			activeEmailKey !== "all" && activeItems.length > 0
				? categories.filter((cat) => !activeItems.some((entry) => entry.cat === cat))
				: [];
		const copyTitle =
			activeMainKey === "all"
				? "All copy"
				: activeIntentKey === "all"
				? (mainTabs.find((tab) => tab.key === activeMainKey) || {}).label
				: activeEmailKey === "all"
				? [
						(mainTabs.find((tab) => tab.key === activeMainKey) || {}).label,
						(intentTabs.find((tab) => tab.key === activeIntentKey) || {}).label
				  ]
						.filter(Boolean)
						.join(" ")
				: sortedItems[0] && sortedItems[0].item
				? sortedItems[0].item.title
				: "";

		return (
			<div className="admin-field">
				<p className="admin-help">
					Copy is grouped by entry name. Pick the campaign family, incentive type, and email number, then
					edit each category-specific version.
				</p>
				{entries.length === 0 && <p className="admin-help">No copy entries yet.</p>}
				{industryOptions.length > 1 && (
					<div className="admin-select-row">
						<label>Industry</label>
						<select
							className="admin-select"
							value={activeIndustry}
							onChange={(e) => this.setActiveTab(industryTabKey, e.target.value)}
						>
							{industryOptions.map((option) => (
								<option key={option.key} value={option.key}>
									{option.label} ({option.count})
								</option>
							))}
						</select>
					</div>
				)}
				{this.renderTabs(mainTabKey, mainTabs, activeMainKey, "primary")}
				{mainEntries.length > 0 && (
					<React.Fragment>
						{this.renderTabs(intentTabKey, intentTabs, activeIntentKey, "secondary")}
						{this.renderTabs(emailTabKey, emailTabs, activeEmailKey, "tertiary")}
						<div className="copy-group-summary">
							<span className="copy-group-title">{copyTitle || "Copy"}</span>
							<span className="copy-group-meta">{sortedItems.length} entries</span>
						</div>
						{sortedItems.length === 0 && <p className="admin-help">No entries in this group.</p>}
						<div className="copy-entry-grid">
							{sortedItems.map(({ cat, index, item }) => (
								<div className="copy-category-card" key={cat + "_" + index}>
									<div className="nested-group-head">
										<input
											className="group-name"
											value={cat}
											readOnly={!canEdit}
											onChange={(e) => this.renameCopyCategory(setting, cat, e.target.value)}
										/>
										{canEdit && (
											<button
												type="button"
												className="dept-delete"
												title="Delete category"
												onClick={() => this.removeCopyCategory(setting, cat)}
											>
												&times;
											</button>
										)}
									</div>
									<div className="nested-card">
										<div className="nested-card-head">
											<span className="nested-card-title">
												{item.title || "Entry " + (index + 1)}
											</span>
											{canEdit && (
												<button
													type="button"
													className="dept-delete"
													title="Delete entry"
													onClick={() => this.removeCopyItem(setting, cat, index)}
												>
													&times;
												</button>
											)}
										</div>
										{this.renderObjectFields(item, canEdit, (field, val) =>
											this.updateCopyField(setting, cat, index, field, val)
										)}
									</div>
								</div>
							))}
						</div>
						{missingCategories.length > 0 && (
							<p className="admin-help compact">
								Missing from {missingCategories.length} categories. Use Text mode for bulk additions.
							</p>
						)}
					</React.Fragment>
				)}
			</div>
		);
	}

	renderTestsEditor(setting, canEdit) {
		const groups = this.getTestGroups(setting);
		const tabKey = setting.title + ":tests:section";
		const total = groups.reduce((sum, group) => sum + group.count, 0);
		const tabs = groups.length > 0 ? [{ key: "all", label: "All", count: total }, ...groups] : [];
		const activeKey = this.getActiveTab(tabKey, tabs);
		const activeGroup = groups.find((group) => group.key === activeKey);
		const activeItems =
			activeKey === "all" ? groups.reduce((items, group) => [...items, ...group.items], []) : activeGroup ? activeGroup.items : [];
		return (
			<div className="admin-field">
				<p className="admin-help">Each entry is a test case shown to QA. Sections are grouped into tabs.</p>
				{setting.title === "ai_tests" && (
					<p className="admin-help">
						AI Review also adds every review_tests entry as a code check. Optional keys: <b>method</b> = csd, code,
						browser (default) or human; checks run in that order and human checks are never sent to the agent.{" "}
						<b>requires</b> = CSD field ids the check needs, e.g. <code>coupon_code|incentive_type, !type:pc</code>{" "}
						(comma = and, | = or, ! = must be empty, * = prefix, type: = CSD type). <b>fields</b> = CSD field ids
						whose values are sent to the agent as context, e.g. <code>coupon_code, design_*</code>.
					</p>
				)}
				{groups.length === 0 && <p className="admin-help">No tests yet.</p>}
				{this.renderTabs(tabKey, tabs, activeKey, "primary")}
				{activeItems.length > 0 && (
					<div className="nested-group test-section-group">
						<div className="nested-group-head">
							<span className="section-title">{activeKey === "all" ? "All sections" : activeGroup.label}</span>
							<span className="section-count">{activeItems.length} tests</span>
						</div>
						{activeItems.map(({ test, index }) => (
							<div className="nested-card" key={index}>
								<div className="nested-card-head">
									<span className="nested-card-title">{test.case || "Case " + (index + 1)}</span>
									{canEdit && (
										<button
											type="button"
											className="dept-delete"
											title="Delete test"
											onClick={() => this.removeTest(setting, index)}
										>
											&times;
										</button>
									)}
								</div>
								{this.renderObjectFields(test, canEdit, (field, val) =>
									this.updateTestField(setting, index, field, val)
								)}
							</div>
						))}
					</div>
				)}
			</div>
		);
	}

	renderFooterAddAction(setting, canEdit) {
		if (!canEdit || !setting) return null;
		const mode = this.state.editorMode[setting.title] || "visual";
		if (mode === "text") return null;

		if (setting.title === "departments") {
			return (
				<button type="button" className="inline-add" onClick={() => this.addDepartment(setting)}>
					+ Add department
				</button>
			);
		}

		if (setting.title === "copy_data") {
			return (
				<button type="button" className="inline-add" onClick={() => this.addCopyCategory(setting)}>
					+ Add category
				</button>
			);
		}

		if (setting.title.match("_tests")) {
			const groups = this.getTestGroups(setting);
			const total = groups.reduce((sum, group) => sum + group.count, 0);
			const tabs = groups.length > 0 ? [{ key: "all", label: "All", count: total }, ...groups] : [];
			const activeKey = this.getActiveTab(setting.title + ":tests:section", tabs);
			const activeGroup = groups.find((group) => group.key === activeKey);
			return (
				<button
					type="button"
					className="inline-add"
					onClick={() => this.addTest(setting, activeGroup && activeKey !== "all" ? activeGroup.label : "")}
				>
					+ Add test
				</button>
			);
		}

		return null;
	}

	renderEditor(setting, canEdit) {
		const isTests = Boolean(setting.title.match("_tests"));
		const structured =
			setting.title === "tags" ||
			setting.title === "departments" ||
			setting.title === "copy_data" ||
			isTests;
		if (!structured) return this.renderGenericEditor(setting, canEdit);

		const mode = this.state.editorMode[setting.title] || "visual";
		let visual;
		if (setting.title === "tags") visual = this.renderTagsEditor(setting, canEdit);
		else if (setting.title === "departments") visual = this.renderDepartmentsEditor(setting, canEdit);
		else if (setting.title === "copy_data") visual = this.renderCopyEditor(setting, canEdit);
		else visual = this.renderTestsEditor(setting, canEdit);

		return (
			<React.Fragment>
				{this.renderModeToggle(setting)}
				{mode === "text" ? this.renderTextMode(setting, canEdit) : visual}
			</React.Fragment>
		);
	}

	renderAddSetting() {
		return (
			<div className="admin-panel">
				<div className="admin-panel-head">
					<h1>Add Setting</h1>
					<div className="desc">Create a new admin setting.</div>
				</div>
				<div className="admin-panel-body">
					<form onSubmit={this.add}>
						<div className="admin-field">
							<label>Title</label>
							<input
								className="admin-input"
								name="title"
								value={this.state.title}
								onChange={this.handleChange}
							/>
						</div>
						<div className="admin-field">
							<label>Value</label>
							<textarea
								className="admin-textarea mono"
								name="value"
								value={this.state.value}
								onChange={this.handleChange}
							/>
						</div>
						<button type="submit" className="btn-save">
							Add Setting
						</button>
					</form>
				</div>
			</div>
		);
	}

	render() {
		let cookies = new Cookies();
		if (this.state.redirect) {
			return <Navigate to={this.state.redirect} />;
		}
		const isManager =
			this.state.user && this.state.settings && this.state.user.profile.email.match(this.state.settings.managers);
		const isEditor =
			this.state.user && this.state.settings && this.state.user.profile.email.match(this.state.settings.editors);

		return (
			<React.Fragment>
				<Helmet>
					<title>Upsellit Docs Admin</title>
				</Helmet>
				<GlobalStyle />
				<AdminGlobalStyle />
				<WikiWrapperEl>
					<header className={"header-wrapper"}>
						<nav className="top-navigation">
							<div className="menu-item" style={{ minWidth: "10em", marginRight: "auto" }}>
								<button className="btn btn-link btn-logo">
									<a href={origin + "/"}>
										<img src={logo} alt={"logo"} className={"icon"} />
									</a>{" "}
									<a
										href={origin + "/admin"}
										style={{ fontSize: "1.5em", paddingLeft: "1em", letterSpacing: "2px" }}
									>
										Docs Admin {this.angleIcon}
									</a>
								</button>
								<div className="sub-menu">
									<ul style={{ paddingLeft: "1em" }}>
										<li>
											<a href={origin + "/wiki"} className="btn btn-link btn-block">
												Wiki
											</a>
										</li>
										<li>
											<a href={origin + "/"} className="btn btn-link btn-block">
												CSD
											</a>
										</li>
										<li>
											<a
												href="https://www2.upsellit.com/admin/control/edit/index.jsp"
												target="_blank"
												rel="noreferrer"
												className="btn btn-link btn-block"
											>
												Admin
											</a>
										</li>
										<li>
											<a
												href="https://upsellit.lightning.force.com/lightning"
												target="_blank"
												rel="noreferrer"
												className="btn btn-link btn-block"
											>
												Salesforce
											</a>
										</li>
									</ul>
								</div>
							</div>
							{this.state.user && (
								<div style={{ marginRight: "1em", minWidth: "5em" }}>
									<div className="menu-item">
										<div className="">
											<button
												className="profile-button btn btn-link"
												style={{ backgroundImage: `url(${this.state.user.profile.picture})` }}
											></button>{" "}
											<span style={{ marginTop: "1.25em", display: "inline-block" }}>
												{this.angleIcon}
											</span>
										</div>
										<div className="sub-menu">
											<ul>
												<li>
													<button
														className="btn btn-link btn-block"
														onClick={(e) => {
															let theme = cookies.get("theme") || "dark";
															if (theme === "light") {
																cookies.set("theme", "dark", { path: "/" });
																document.documentElement.id = "dark";
															} else {
																cookies.set("theme", "light", { path: "/" });
																document.documentElement.id = "light";
															}
														}}
													>
														<span
															className="icon"
															style={{
																background: "var(--icon-moon-g)"
															}}
														></span>
														Theme
													</button>
												</li>
												<li>
													{this.state.settings && isEditor && (
														<a href="/admin/" className="btn btn-link btn-block">
															<span
																className="icon"
																style={{
																	background: "var(--icon-team-lg)"
																}}
															></span>
															Docs Admin
														</a>
													)}
												</li>
												<li>
													<a
														href="/wiki/wiki_browsing_and_editing"
														className="btn btn-link btn-block"
													>
														<span className="icon" style={{}}>
															?
														</span>
														Help
													</a>
												</li>
												<li>
													{this.state.user && (
														<button
															onClick={() => this._handleLogout()}
															className="btn btn-link btn-block"
														>
															<span
																className="icon"
																style={{
																	background: "var(--icon-logout-g)"
																}}
															></span>
															Logout
														</button>
													)}
												</li>
											</ul>
										</div>
									</div>
								</div>
							)}
						</nav>
					</header>
					<Routes>
						<Route path="/" element={
							this.state.user ? (
								<AdminConsoleEl>
									<nav className="admin-nav">
										<div className="admin-nav-title">Settings</div>
										{this.state.form.map((s, i) => (
											<button
												type="button"
												key={s._id}
												className={
													"admin-nav-item" +
													(!this.state.showAdd && i === this.state.activeIndex
														? " active"
														: "")
												}
												onClick={() => this.selectSetting(i)}
											>
												<span>{s.title}</span>
											</button>
										))}
										{this.state.user.profile.email.match("broche|cwampler|ejarnit") && (
											<div className="admin-nav-add">
												<button
													type="button"
													onClick={() => this.setState({ showAdd: true })}
												>
													+ Add setting
												</button>
											</div>
										)}
									</nav>
									{this.state.showAdd &&
									this.state.user.profile.email.match("broche|cwampler|ejarnit") ? (
										this.renderAddSetting()
									) : this.state.form[this.state.activeIndex] ? (
										(() => {
											const active = this.state.form[this.state.activeIndex];
											const canEdit = Boolean(isManager || isEditor);
											return (
												<div className="admin-panel">
													<div className="admin-panel-head">
														<h1>{active.title}</h1>
														{active.description && (
															<div className="desc">{active.description}</div>
														)}
													</div>
													<div className="admin-panel-body">
														{this.renderEditor(active, canEdit)}
													</div>
													<div className="admin-save-bar">
														{this.state.savedTitle === active.title && (
															<span className="saved-note">Saved &#10003;</span>
														)}
														{this.renderFooterAddAction(active, canEdit)}
														<button
															type="button"
															className="btn-save"
															disabled={
																!canEdit ||
																this.state.savingTitle === active.title
															}
															onClick={() => this.saveSetting(active)}
														>
															{this.state.savingTitle === active.title
																? "Saving…"
																: "Save changes"}
														</button>
													</div>
												</div>
											);
										})()
									) : (
										<div className="admin-panel">
											<div className="admin-panel-body">
												<p className="admin-help">No settings found.</p>
											</div>
										</div>
									)}
								</AdminConsoleEl>
							) : (
								<div />
							)
						} />
						<Route path="*" element={
							<p>Route not found</p>
						} />
					</Routes>
				</WikiWrapperEl>
			</React.Fragment>
		);
	}
}

export default withRouterV6(withAuth(AdminWrapper));
